module.exports = __webpack_public_path__ + "img/collection-weddingRingsHearts@2x.be13c8d.webp";